import React, { useEffect, useState } from 'react'
import ResetPasswordForm from './components/ResetPasswordForm'
import LoginLayout from './LoginLayout'
import { useNavigate } from 'react-router-dom'
import errorToast from '../../Components/Toasts/ErrorToast'
import { app_sso } from '../../firebase'
import {
  getAuth,
  isSignInWithEmailLink,
  signInWithEmailLink,
} from 'firebase/auth'

function ResetPasswordPage() {
  const navigate = useNavigate()
  const [authorized, setAuthorized] = useState(false)

  useEffect(() => {
    const authenticate = async () => {
      try {
        const auth = getAuth(app_sso)
        const url = window.location.href
        const searchParams = new URLSearchParams(window.location.search)
        const encodedEmail = searchParams.get('ou')
        if (!encodedEmail) throw new Error('Missing email info in link')

        const email = atob(encodedEmail)

        if (!isSignInWithEmailLink(auth, url)) {
          throw new Error('Invalid or expired sign-in link')
        }
        await signInWithEmailLink(auth, email, url)
        setAuthorized(true)
      } catch (error) {
        console.error(error)
        errorToast('Reset password link is invalid or expired')
        navigate('/login')
      }
    }

    authenticate()
  }, [])

  return <LoginLayout>{authorized && <ResetPasswordForm />}</LoginLayout>
}

export default ResetPasswordPage
